import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loadingTrans: false,
  transactions: [],
  paginationTrans: {
    page: 1,
    limit: 10,
    total: -1,
  },
});

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    LOAD_TRANSACTIONS: (s, data) => (s.loadingTrans = data),
    SET_TRANSACTIONS: (s, data) => {
      s.transactions = data.transactions;
      s.paginationTrans = data.pagination;
    },
    RESET: (s) => Object.assign(s, initState()),
  },

  actions: {
    async getTransactions({ commit }, params) {
      commit("LOAD_TRANSACTIONS", true);
      try {
        const res = await this.$api.get("/v1/portal/transactions", { params });
        const { data, pagination } = res.data;
        commit("SET_TRANSACTIONS", {
          transactions: data,
          pagination,
        });
        return data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_TRANSACTIONS", false);
      }
    },
  },
};
